<template>
  <main class="release-details">
    <div class="release-details__content">
      <div class="release-details__copy-wrapper">
        <h2 class="text-h2 text-color-navy release-details__title" v-html="release.title" />
        <div v-if="release.date" class="text-h3 text-color-navy release-details__date">
          <span v-html="getFullDate(release.date)" />
        </div>
        <div v-if="release.description" class="release-details__description">
          <RichRenderer :richTextData="release.description" />
        </div>
        <div v-if="release.paragraph" class="release-details__description">
          <RichRenderer :richTextData="release.paragraph" />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import dayjs from '@/lib/utils/dayjs'

import { useBreadcrumbsStore } from '@/stores/breadcrumbs'

export default {
  name: 'ReleaseDetails',
  props: {
    activeEntry: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const breadcrumbsStore = useBreadcrumbsStore()
    return {
      breadcrumbsStore,
    }
  },
  data() {
    return {
      release: {},
    }
  },
  mounted() {
    this.release = this.activeEntry
    this.breadcrumbsStore.setPathExtend([{ name: this.release.title }])
  },
  methods: {
    getFullDate(date) {
      return dayjs(date).format('LL')
    },
  },
}
</script>
